import assessmentActions from '../actions/AssessmentActions';
import storeManager from '../store/StoreManager';
import sessionReader from '../store/readHelpers/SessionReader';
import settingsReader from '../store/readHelpers/SettingsReader';
import apiService from './api/ApiService';

const dataLoadingService = {
    loadSketchCodeForQuestion(questionId) {
        const store = storeManager.getStore();
        const isContextPreview = sessionReader.isContextPreview() || sessionReader.isContextViewGradingQuestionPreview();

        if (!settingsReader.areAttachedSketchesEnabled() || (sessionReader.isModeQuestion() && isContextPreview)) {
            return undefined;
        }

        return apiService.fetchSketchCodeForQuestion(questionId)
            .then((sketchCode) => {
                store.dispatch(assessmentActions.assessmentSketchCodeLoaded({
                    [questionId]: sketchCode,
                }));
            });
    },
    shouldLoadCorrectResponses() {
        return (
            !sessionReader.isContextViewGradingQuestionPreview() && !sessionReader.isContextThumbnail()
            && !(
                sessionReader.isContextViewOwnDelivery()
                && !settingsReader.showCorrectResponsesPostDelivery()
            )
        );
    },
};

export default dataLoadingService;
